import React, { createContext, useContext, useEffect, useState } from 'react';
import { adminLogin } from '../api/adminApi';

const AuthContext = createContext(null);
const STORAGE_KEY = 'cinemaz_admin_auth';

export function AuthProvider({ children }) {
  const [token, setToken] = useState(null);
  const [username, setUsername] = useState(null);
  const [initializing, setInitializing] = useState(true);

  // Restore session on page load/refresh
  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        setToken(parsed.token);
        setUsername(parsed.username);
      } catch {
        localStorage.removeItem(STORAGE_KEY);
      }
    }
    setInitializing(false);
  }, []);

  async function login(usernameInput, password) {
    const data = await adminLogin(usernameInput, password);
    setToken(data.token);
    setUsername(data.username);
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ token: data.token, username: data.username }));
    return data;
  }

  function logout() {
    setToken(null);
    setUsername(null);
    localStorage.removeItem(STORAGE_KEY);
  }

  return (
    <AuthContext.Provider value={{ token, username, login, logout, initializing }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within an AuthProvider');
  return ctx;
}
